export default {
  "staffRiskInsight": () => import("../addons/hrm-addon-staff-change-risk/views/StaffChangeRiskOverview.vue"),
  "retentionRiskInsight": () => import("../addons/hrm-addon-retention-risk-insight/views/RetentionRiskInsightOverview.vue"),
  "contractProbationAlert": () => import("../addons/hrm-addon-contract-probation-alert/views/ContractProbationAlertOverview.vue")
}
